import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import React from 'react';
import styled, { css } from 'styled-components';

import { useAppSelector } from '@/redux/hooks';
import { getCatalogLotsListed } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getLiveCatalogCurrentItemId } from '@/redux/modules/console';
import { getItemSummaryIndex } from '@/redux/modules/item/summary/itemSummary.selectors';

import { useCalculateNextFavorite } from './hooks/useCalculateNextFavorite';

type Props = {
    catalogId: number;
};

const AuctionLotTracker = ({ catalogId }: Props) => {
    const itemId = useAppSelector((state) => getLiveCatalogCurrentItemId(state, catalogId));
    const totalLotsListed = useAppSelector((state) => getCatalogLotsListed(state, catalogId));
    const index = useAppSelector((state) => getItemSummaryIndex(state, itemId));

    const nextFavorite = useCalculateNextFavorite({ catalogId, itemId });
    // const bidderNextBid = useCalculateNextBid({ catalogId, itemId });

    const percent = Math.round(((index + 1) / totalLotsListed) * 100);
    const remaining = totalLotsListed - index;

    return (
        <Container>
            {!isNaN(remaining) && !isNaN(totalLotsListed) && (
                <BodyPrimary>
                    <FormattedMessage
                        id="bidding_console.console.status.remaining"
                        values={{ remaining, total: totalLotsListed }}
                    />
                </BodyPrimary>
            )}
            <ProgressBar>{!isNaN(percent) && <Bar $percent={percent} />}</ProgressBar>
            {/* {bidderNextBid !== 0 && (
                <NextBidWrapper>
                    <H5>
                        <FormattedMessage id="bidding_console.console.status.nextBid.text" />
                    </H5>
                    <StyledPrimaryRed>
                        <FormattedMessage
                            id="bidding_console.console.status.nextBid.value"
                            values={{ total: bidderNextBid }}
                        />
                    </StyledPrimaryRed>
                </NextBidWrapper>
            )} */}
            {nextFavorite !== 0 && (
                // TODO change this to !bidderNextBid
                <NextFavoriteWrapper $addMargin>
                    <H5>
                        <FormattedMessage id="bidding_console.console.status.nextFavorite.text" />
                    </H5>
                    <StyledPrimary
                        $isClose={nextFavorite && nextFavorite <= 10}
                        color="secondary"
                    >
                        <FormattedMessage
                            id="bidding_console.console.status.nextFavorite.value"
                            values={{ total: nextFavorite }}
                        />
                    </StyledPrimary>
                </NextFavoriteWrapper>
            )}
        </Container>
    );
};

export default AuctionLotTracker;

const Container = styled.div`
    background: ${({ theme }) => theme.colors.white};
    padding: 24px;
    border: 1px solid ${({ theme }) => theme.colors.grey400};
    border-bottom: none;
    transition: 2s;
`;

const ProgressBar = styled.div`
    width: 100%;
    background-color: ${({ theme }) => theme.colors.grey500};
    height: 8px;
    margin-top: 8px;
    transition: all 0.3s ease-out;
    border-radius: 100px;
    overflow: hidden;
`;

const Bar = styled.div<{ $percent: number }>`
    background-color: ${({ theme }) => theme.colors.blue100};
    height: 8px;
    width: ${({ $percent }) => $percent}%;
`;

// const StyledPrimaryRed = styled(BodyPrimary)`
//     color: ${({ theme }) => theme.colors.red100};
//     margin-left: 8px;
// `;

const StyledPrimary = styled(BodyPrimary)<{ $isClose: boolean }>`
    margin-left: 8px;
    ${({ $isClose }) => {
        if ($isClose) {
            return css`
                color: ${({ theme }) => theme.colors.red100};
            `;
        }
    }}
`;
// const NextBidWrapper = styled.div`
//     margin: 24px 0 8px 0;
// `;

const NextFavoriteWrapper = styled.div<{ $addMargin: boolean }>`
    ${({ $addMargin }) => {
        if ($addMargin) {
            return css`
                margin: 24px 0 0;
            `;
        }
    }}
`;
